import { Outlet } from 'react-router-dom';
import DashboardLayout from '../../layouts/DashboardLayout';
import { LayoutDashboard, Lightbulb, Trophy, Settings, Users, UserCheck, ClipboardList, UserPlus } from 'lucide-react';

const adminMenuItems = [
    {
        title: 'Dashboard',
        to: '/admin-dashboard',
        icon: <LayoutDashboard className="w-4 h-4" />,
        end: true,
    },
    {
        title: 'Add Member',
        to: '/admin-dashboard/add-member',
        icon: <UserPlus className="w-4 h-4" />,
    },
    {
        title: 'Mentor Assignment',
        to: '/admin-dashboard/mentor-assignment',
        icon: <UserCheck className="w-4 h-4" />,
    },
    {
        title: 'Manage Panels',
        to: '/admin-dashboard/manage-panels',
        icon: <Users className="w-4 h-4" />,
    },
    // {
    //     title: 'Leaderboard',
    //     to: '/admin-dashboard/leaderboard',
    //     icon: <Trophy className="w-4 h-4" />,
    // },
    {
        title: 'Manage Hackathon',
        to: '/admin-dashboard/manage-hackathon',
        icon: <Settings className="w-4 h-4" />,
    },
];

export function Layout() {
    return (
        <DashboardLayout menuItems={adminMenuItems}>
            <Outlet />
        </DashboardLayout>
    );
}